import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, Typography, FormControl, TextField } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import PageTitle from '../../components/PageTitle/PageTitle';
import IconButton from '@material-ui/core/IconButton';
// import CustomToolbar from "./CustomToolbar";
import * as Icons from '@material-ui/icons';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/LoaderView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage, setSelectTenant } from '../../utils/common';
import moment from 'moment';
import CustomFooter from '../../components/Table/CustomFooter';
import SelectTenant from '../../components/Select/SelectTenant';

class AreasManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: 0,
    };
  }
  async componentDidMount() {
    const { offset, limit, search, sort, order, action, tenantIds } = this.props.area.toJS();
    if (action) {
      this.setState({
        tenant: tenantIds && tenantIds.length > 0 ? JSON.stringify(tenantIds) : 0,
      });

      await this.props.area.getAreas(offset, limit, search, sort, order, tenantIds);
      this.props.area.setAction('action', null);
      this.props.router.resetData();
    } else {
      const tenantIds = localStorage.getItem('select_tenant') ? [+localStorage.getItem('select_tenant')] : null;
      this.setState({
        tenant: tenantIds ? JSON.stringify(tenantIds) : 0,
      });

      this.props.router.resetData();
      this.props.area.resetData();
      await this.props.area.setData('tenantIds', tenantIds);
      // await this.props.area.getAreas(0,15);
    }
  }

  createArea() {
    const { classes, t } = this.props;
    return (
      <Button
        variant='outlined'
        color='primary'
        onClick={() => this.props.history.push('areas/create')}
        className={classes.button}
        id='createAreaBtn'
      >
        <Icons.Add />
        {t('create_area')}
      </Button>
    );
  }

  titleContent() {
    const { classes, t } = this.props;
    const { search } = this.props.area.toJS();
    return (
      <div className={classes.titleBar}>
        <SelectTenant handleChangeTenant={this.handleChangeTenant} tenant={this.state.tenant} />
        <Grid className={classes.search}>
          <FormControl variant='outlined' className={classes.formControl} fullWidth>
            <TextField
              variant='outlined'
              size='small'
              value={search || ''}
              name='search'
              id='search'
              className={classes.contentInput}
              placeholder={t('search')}
              onChange={(e) => this.handleChangeSearch(e)}
            ></TextField>
          </FormControl>
        </Grid>
      </div>
    );
  }

  handleChangeSearch = (event) => {
    const { value } = event.target;
    this.props.area.setData('offset', 0, false);
    this.props.area.setData('search', value);
  };

  handleChangeTenant = async (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });

    const tenantIds = JSON.parse(value);
    await this.props.area.setData('tenantIds', tenantIds);
    setSelectTenant(tenantIds);
  };

  validateTableRow = (data, expectedSize) => {
    return data && Array.isArray(data) && data.length === expectedSize;
  };

  handleChangeRowsPerPage = (value) => {
    this.props.area.setData('limit', value);
  };

  handlechangePage = (value) => {
    const { limit } = this.props.area.toJS();
    this.props.area.setData('offset', value * limit);
  };

  deleteItem(id) {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
              <i
                class="fa fa-trash-o fa-3x fa-border"
                style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
              </i>
            </span>
            <br/>
            <h4>${t('delete_area')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.area.deleteArea(id);
          if (result.statusCode === 200) {
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' }).then(async (resultSuccess) => {
              if (resultSuccess.value) {
                const { offset, limit, search, sort, order, tenantIds } = this.props.area.toJS();
                await this.props.area.getAreas(offset, limit, search, sort, order, tenantIds);
                // await this.props.area.getAreas(0,15);
              }
            });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  }

  render() {
    const { classes, t } = this.props;
    let { areas, loading, limit, search, sort, order } = this.props.area.toJS();
    const page = areas.data ? areas.pagination.page - 1 : 0;
    const count = areas.data ? areas.pagination.count : 0;

    const ARRAYSIZE = 6;
    const columns = [
      {
        name: 'id',
        label: `${t('id')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'id' && order ? order : 'none',
        },
      },
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          sortDirection: sort === 'name' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[1]}</div>;
          },
        },
      },
      {
        name: 'routerNo',
        label: `${t('no_of_routers')}`,
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[2]}</div>;
          },
        },
      },
      {
        name: 'tenant.name',
        label: `${t('tenant')}`,
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{this.validateTableRow(row, ARRAYSIZE) && row[3]}</div>;
          },
        },
      },
      {
        name: 'modifiedDate',
        label: `${t('modified_date')}`,
        options: {
          filter: false,
          sort: false,
          sortDirection: sort === 'modifiedDate' && order ? order : 'none',
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div>
                <Typography>{moment(row[4]).format('DD MMM YYYY hh:mm:ss A')}</Typography>
              </div>
            );
          },
        },
      },
      {
        name: '',
        label: `${t('action')}`,
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={classes.actionBox}>
                <Link
                  to={`/app/areas/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/view`}
                  title={t('view')}
                  id='viewLocationBtn'
                >
                  <IconButton>
                    <Icons.FormatListBulleted color='primary' />
                  </IconButton>
                </Link>
                <Link
                  to={`/app/areas/${this.validateTableRow(row, ARRAYSIZE) ? row[0] : ''}/edit`}
                  title={t('edit')}
                  id='editLocationBtn'
                >
                  <IconButton>
                    {' '}
                    <Icons.Edit color='primary' />
                  </IconButton>
                </Link>
                <IconButton
                  title={t('delete')}
                  id='deleteIcon'
                  onClick={() => this.deleteItem(this.validateTableRow(row, ARRAYSIZE) ? row[0] : '')}
                >
                  <Icons.Delete color='primary' />
                </IconButton>
              </div>
            );
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <PageTitle title={t('all_areas')} button={this.createArea()}>
          {this.titleContent()}
        </PageTitle>
        <Grid className={classes.mainContain} container spacing={32}>
          <Grid item xs={12}>
            <MUIDataTable
              data={areas.data}
              columns={columns}
              options={{
                count: areas.data ? areas.pagination.count : 0,
                page: areas.data ? areas.pagination.page - 1 : 0,
                searchText: search,
                serverSide: true,
                pagination: true,
                onTableChange: (action, tableState) => {
                  // console.log(action, tableState);
                  switch (action) {
                    case 'changePage':
                      this.props.area.setData('offset', tableState.page * tableState.rowsPerPage);
                      // this.props.user.setData('page',tableState.page);
                      break;
                    case 'changeRowsPerPage':
                      this.props.area.setData('limit', tableState.rowsPerPage);
                      break;
                    case 'search':
                      this.props.area.setData('offset', 0, false);
                      this.props.area.setData('search', tableState.searchText);
                      break;
                    case 'sort':
                      const sortList = tableState.announceText.split(' ');
                      this.props.area.setData('offset', 0, false);
                      this.props.area.setData('sort', sortList[4], false);
                      this.props.area.setData('order', sortList[6] === 'descending' ? 'desc' : 'asc');
                      break;
                    default:
                      break;
                  }
                },
                print: false,
                download: false,
                viewColumns: false,
                search: false,
                sortFilterList: true,
                sort: true,
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'dropdown',
                responsive: 'scrollFullHeight',
                rowsPerPageOptions: [10, 15, 50],
                rowsPerPage: limit,
                customFooter: (rowsPerPage, changeRowsPerPage, changePage, textLabels) => {
                  return (
                    <CustomFooter
                      count={count}
                      page={page}
                      rowsPerPage={limit}
                      changeRowsPerPage={this.handleChangeRowsPerPage}
                      changePage={this.handlechangePage}
                      textLabels={textLabels}
                      rowsPerPageOptions={[10, 15, 50]}
                    />
                  );
                },
              }}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  mainContain: {
    marginTop: '5px',
    padding: 16,
  },
  actionBox: {
    minWidth: '200px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  button: {
    height: '38px',
    margin: theme.spacing.unit / 2,
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
    marginLeft: theme.spacing.unit * 2,
  },
  contentInput: {
    '& fieldset': {
      top: '2px',
    },
    '& input': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  titleBar: {
    display: 'flex',
    marginTop: '-5px',
  },
  search: {
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
  },
});

export const page = inject('area', 'router')(observer(AreasManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
